/**
 * Created by claudio iozzia on 22/06/2017.
 */
import {IAppSpec} from "../../Redux/selector.state";
import {Ic} from "../common";
import {acceptAll, acceptAllOutput, Acceptor, AcceptorFn, AcceptorOutputFn, IAcceptor} from "./IAcceptor";
import {Utils} from "../../common/utils";
import {ISingleOutput} from "../ISpec";
import {FeatureFilterState} from "../features/feature_const";
import {dcLED_NumLED_acceptor} from "../../solution-type/LED/dcdc/acceptor/dcLED_Common_acceptor";

const statusCheckAcceptor: AcceptorFn = (ic: Ic, spec: IAppSpec): boolean => {
  const ret = (Utils.getFieldValue(ic, "status", "active").toString().toLowerCase() !== 'obsolete');   // check status
  // console.log("StatusCheck", ret);
  return ret;

};

const inputMinGenericAcceptor: AcceptorFn = (ic: Ic, spec: IAppSpec): boolean => {
  const _vin_min = spec.spec.value.input.min;
  const ret = (Utils.isValueEmpty(_vin_min) || ic.vin_min <= _vin_min);   // Vin min filter
  // console.log("InputMinGeneric", ret);
  return ret;
};

const inputMaxGenericAcceptor: AcceptorFn = (ic: Ic, spec: IAppSpec): boolean => {
  const _vin_max = spec.spec.value.input.max;
  const ret = (Utils.isValueEmpty(_vin_max) || ic.vin_max >= _vin_max);       // Vin max filter
  // console.log("InputMaxGeneric", ret);
  return ret;

};

const outputGenericAcceptor: AcceptorFn = (ic: Ic, spec: IAppSpec): boolean => {
  const _num_outputs = spec.spec.value.output.outputs.length;
  const maxNumOutput: number = Utils.getFieldValue(ic, 'designData.maxNumOutput', 1);
  const minNumOutput: number = Utils.getFieldValue(ic, 'designData.minNumOutput', 1);

  const ret = ((maxNumOutput >= _num_outputs)               // Max Num of output
    // && (minNumOutput >= _num_outputs)           // Min Num of output removed because the min not filter else at the begin the
  );
  // console.log("NumOutputGeneric", ret);
  return ret;

};

const featureGenericAcceptor: AcceptorFn = (ic: Ic, spec: IAppSpec): boolean => {
  const ret = spec.featuresFilter.length === 0 || spec.featuresFilter.filter(x => {               //feature filter
    if (x.stateFilter === FeatureFilterState.YES) {                // include ic
      return ic.features.find((y) => x.key.localeCompare(Utils.keyCompose(y.feature.label, y.feature.category)) === 0);
    } else if (x.stateFilter === FeatureFilterState.NO) {           // exclude ic
      return !ic.features.find((y) => x.key.localeCompare(Utils.keyCompose(y.feature.label, y.feature.category)) === 0);
    } else {
      return true;                                                  // don't care
    }
  }).length === spec.featuresFilter.length;   // all feature filter must match
  // console.log("FeatureGeneric", ret);
  return ret;

};

export class Acceptor_Common extends Acceptor {
  public static createAcceptor(a: Ic): IAcceptor {
    return new Acceptor_Common();
  }

  constructor(protected ledDcDc: boolean = false) {
    super();
  }

  protected get status(): AcceptorFn {
    return statusCheckAcceptor;
  }

  protected get inputMin(): AcceptorFn {
    return inputMinGenericAcceptor;
  }

  protected get inputMax(): AcceptorFn {
    return inputMaxGenericAcceptor;
  }

  protected get numberOutputs(): AcceptorFn {
    return this.ledDcDc ? acceptAll : outputGenericAcceptor;
  }

  protected get numberLeds(): AcceptorFn {
    return this.ledDcDc ? dcLED_NumLED_acceptor : acceptAll;
  }

  protected singleOutputV(): AcceptorOutputFn {
    return acceptAllOutput;
  }

  protected singleOutputI(): AcceptorOutputFn {
    return acceptAllOutput;
  }

  protected singleOutputP(): AcceptorOutputFn {
    return acceptAllOutput;
  }

  protected get singleOutput(): AcceptorOutputFn {
    return (a: Ic, spec: IAppSpec, out: ISingleOutput<number>, i: number): boolean =>
      this.singleOutputV()(a, spec, out, i)
      && this.singleOutputI()(a, spec, out, i)
      && this.singleOutputP()(a, spec, out, i);
  }

  protected globalOutputV(): AcceptorFn {
    return acceptAll;
  }

  protected globalOutputI(): AcceptorFn {
    return acceptAll;
  }

  protected globalOutputP(): AcceptorFn {
    return acceptAll;
  }

  protected get globalOutput(): AcceptorFn {
    return (a: Ic, spec: IAppSpec): boolean =>
      this.globalOutputV()(a, spec)
      && this.globalOutputI()(a, spec)
      && this.globalOutputP()(a, spec);
  }

  protected get output(): AcceptorFn {
    return (a: Ic, spec: IAppSpec): boolean => {
      const ret = (this.ledDcDc
          ? this.singleOutput(a, spec, spec.spec.value.output.globalOutput, 0)
          : spec.spec.value.output.outputs.every((out, i) => this.singleOutput(a, spec, out, i))
        )
        && this.globalOutput(a, spec);
      // console.log("test", a, this.ledDcDc, spec.spec.value, ret);
      return ret;
    };
  }

  protected get features(): AcceptorFn {
    return featureGenericAcceptor;
  }

}
